import * as Yup from 'yup';

export const PrestacaoContaValidationSchema = Yup.object().shape({
	isRevisao: Yup.string().nullable().required('Campo obrigatório'),
	observacoes: Yup.string().nullable().when(['isRevisao'], {
		is: isRevisao => isRevisao === 'true',
		then: Yup.string().required('Campo obrigatório em caso de solicitação de revisão'),
	}),
}, [['isRevisao', 'observacoes']]);
